/** Messaggio da errore generico (navigazione, lazy load, HTTP, Error). */
export function resolveUnknownErrorMessage(err: unknown, fallback: string): string {
  if (err == null) {
    return fallback;
  }

  if (typeof err === 'string') {
    const trimmed = err.trim();
    return trimmed || fallback;
  }

  if (typeof err === 'object') {
    const obj = err as Record<string, unknown>;
    const nested = obj['error'];
    const nestedObj =
      nested && typeof nested === 'object' && !Array.isArray(nested)
        ? (nested as Record<string, unknown>)
        : null;

    const validationSource = (obj['errors'] ?? nestedObj?.['errors']) as
      | Record<string, unknown>
      | undefined;
    if (validationSource && typeof validationSource === 'object') {
      const firstValidation = Object.values(validationSource)
        .flatMap((value) => (Array.isArray(value) ? value : []))
        .map((message) => String(message).trim())
        .find(Boolean);
      if (firstValidation) {
        return firstValidation;
      }
    }

    const candidates: unknown[] = [
      nestedObj?.['message'],
      obj['message'],
      obj['error'],
      nestedObj?.['error']
    ];

    for (const candidate of candidates) {
      if (typeof candidate === 'string') {
        const trimmed = candidate.trim();
        if (trimmed) {
          return trimmed;
        }
      }
    }
  }

  if (err instanceof Error) {
    const trimmed = err.message.trim();
    if (trimmed) {
      return trimmed;
    }
  }

  return fallback;
}
